import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosCombustivelModel extends PadraoModel {
  recurso = 'icarros/combustiveis';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Combustíveis Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
